import { render, staticRenderFns } from "./Absence.vue?vue&type=template&id=0604e036&"
import script from "./Absence.vue?vue&type=script&lang=js&"
export * from "./Absence.vue?vue&type=script&lang=js&"
import style0 from "./Absence.vue?vue&type=style&index=0&id=0604e036&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports